import React from "react";
import PagedTable from "../../../../widgets/tables/paged_table";
import { useFormTemplatePaged } from "../../../../_hooks/form_template/use-form-template-paged.hook";
import { useDeleteTemplate } from "../../../../_hooks/form_template/use-delete-template";
import { Popconfirm } from "antd";
import { Link } from "react-router-dom";
import { paths } from "../../../app_modules";

function Table() {
  const COUNT = 10;
  const formHook = useFormTemplatePaged(0, COUNT);
  const { handleDeleteTemplate } = useDeleteTemplate();
  const [currentPage, setCurrentPage] = React.useState(0);

  const columns = [
    {
      key: "date_created",
      name: "Fecha",
      label: false,
      render: (param) => <span>{param.date_created.split("T")[0]}</span>,
    },
    {
      key: "name",
      name: "Nombre",
      label: false,
      render: (param) => <span>{param.name}</span>,
    },
    {
      key: "semester",
      name: "Semestre",
      label: false,
      render: (param) => <span>{param.semester?.name}</span>,
    },
    {
      key: "_",
      name: "Acción",
      label: false,
      render: (param) => {
        return (
          <div className="flex-row flex-center">
            <Link
              to={`${paths.view_template}?id=${param.uuid}&template-name=${param.name}`}
            >
              <span
                style={{
                  color: "blue",
                  marginRight: "20px",
                  cursor: "pointer",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {/* Root node */}
                  <rect x="9" y="1" width="6" height="4" rx="1" />
                  {/* Left child node */}
                  <rect x="2" y="15" width="6" height="4" rx="1" />
                  {/* Right child node */}
                  <rect x="16" y="15" width="6" height="4" rx="1" />
                  {/* Root to branch line */}
                  <line x1="12" y1="5" x2="12" y2="10" />
                  {/* Horizontal branch */}
                  <line x1="5" y1="10" x2="19" y2="10" />
                  {/* Branch to left child */}
                  <line x1="5" y1="10" x2="5" y2="15" />
                  {/* Branch to right child */}
                  <line x1="19" y1="10" x2="19" y2="15" />
                </svg>
              </span>
            </Link>
            <Popconfirm
              title=""
              description={`Se eliminará el template ${param.name}. ¿Deseas continuar?`}
              onConfirm={() => {
                handleDeleteTemplate(param.uuid, () =>
                  formHook.loadData(currentPage, COUNT),
                );
              }}
              onCancel={() => {}}
              okText="Sí"
              cancelText="No"
            >
              <span style={{ marginLeft: "20px", cursor: "pointer" }}>
                <svg
                  width="30px"
                  height="30px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <path
                      d="M18 6L17.1991 18.0129C17.129 19.065 17.0939 19.5911 16.8667 19.99C16.6666 20.3412 16.3648 20.6235 16.0011 20.7998C15.588 21 15.0607 21 14.0062 21H9.99377C8.93927 21 8.41202 21 7.99889 20.7998C7.63517 20.6235 7.33339 20.3412 7.13332 19.99C6.90607 19.5911 6.871 19.065 6.80086 18.0129L6 6M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M14 10V17M10 10V17"
                      stroke="#e00000"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>{" "}
                  </g>
                </svg>
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const changePage = (page) => {
    setCurrentPage(page);
    formHook.loadData(page, COUNT);
  };

  return (
    <PagedTable
      columns={columns}
      data={formHook.data[0]}
      total={formHook.data[1]}
      dataPerPage={COUNT}
      currentPage={currentPage}
      onChangePage={(page) => changePage(page)}
    />
  );
}

export default Table;
